import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const createEodManifestForIds = {
  name: "createEodManifestForIds" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    carrier: createEnum(Carriers),
  }),
  output: z.object({ success: z.boolean() }),
};
